import useSWR from 'swr';
import { analyticsService, OverviewResponse } from '../services/analyticsService';

interface UseAnalyticsOverviewReturn {
  overview: OverviewResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

export const useAnalyticsOverview = (year: number): UseAnalyticsOverviewReturn => {
  const { data, error, isLoading } = useSWR<OverviewResponse, Error>(
    `/api/v1/analytics/service/overview?year=${year}`,
    () => analyticsService.getOverview(year),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    overview: data,
    loading: isLoading,
    error,
  };
};
